import type { AccountInfo } from "@azure/msal-browser";

/**
 * When several accounts are in the MSAL cache (e.g. after switching users),
 * `getAllAccounts()[0]` is not reliably the current user. Prefer the last entry,
 * which is typically the most recently signed-in account.
 */
export function pickPreferredAccount(accounts: AccountInfo[]): AccountInfo {
  if (accounts.length === 0) {
    throw new Error("pickPreferredAccount: empty accounts");
  }
  return accounts.length === 1 ? accounts[0] : accounts[accounts.length - 1];
}

/**
 * Module-level state survives remounts (Strict Mode) but must be reset on logout
 * or a prior failed redirect can block the next loginRedirect.
 */
let loginRedirectStarted = false;

export function tryBeginLoginRedirect(): boolean {
  if (loginRedirectStarted) return false;
  loginRedirectStarted = true;
  return true;
}

export function resetLoginRedirectGuard(): void {
  loginRedirectStarted = false;
}
